import { render, staticRenderFns } from "./ConsentSectionView.vue?vue&type=template&id=05092c7a&scoped=true&"
import script from "./ConsentSectionView.vue?vue&type=script&lang=ts&"
export * from "./ConsentSectionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05092c7a",
  null
  
)

export default component.exports